/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gas return window._gas.
 * However webpack is not used when running tests from node. Hence,
 * just return googletag of the window object
 */

module.exports = window.googletag;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/googletag.js
// module id = 1209
// module chunks = 63